import React, { createContext, useCallback, useMemo, useState } from 'react';

import { useMediaQuery } from '@chakra-ui/react';

interface ISidebar {
  open: boolean;
  variant: 'sidebar';
  isMobile: boolean;
  isSticked: boolean;
  toggleSidebar(): void;
  toggleStick(): void;
  openSidebar(): void;
  closeSidebar(): void;
}

const SidebarContext = createContext({} as ISidebar);

export const SidebarProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const [isSticked, setIsSticked] = useState<boolean>(false);

  const [isMobile] = useMediaQuery('(max-width: 728px)');

  const toggleSidebar = useCallback((): void => {
    setOpen(!open);
  }, [open]);

  const toggleStick = useCallback((): void => {
    setIsSticked(!isSticked);
  }, [isSticked]);

  const closeSidebar = useCallback((): void => setOpen(false), []);
  const openSidebar = useCallback((): void => setOpen(true), []);

  const value = useMemo(() => {
    return {
      open,
      toggleSidebar,
      isMobile,
      isSticked,
      toggleStick,
      variant: 'sidebar' as const,
      openSidebar,
      closeSidebar,
    };
  }, [
    open,
    toggleSidebar,
    isMobile,
    isSticked,
    toggleStick,
    openSidebar,
    closeSidebar,
  ]);

  return (
    <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
  );
};

export default SidebarContext;
